export const HEADERS_REEMA_IMPERSONATION_USER_ID =
  'x-reema-impersonation-user-id';

/** Local integration / Playwright only — honored when API `INTEGRATION_AUTH_BYPASS=1` and `ENV=local`. */
export const HEADERS_REEMA_INTEGRATION_USER_ID = 'x-reema-integration-user-id';
export const HEADERS_REEMA_INTEGRATION_USER_EMAIL =
  'x-reema-integration-user-email';
